import React, { useState, useEffect } from 'react';
import logo from "../../assets/logo.png";
import "./Menu.css";
import { FaWhatsapp } from 'react-icons/fa';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const Menu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);

  // Prevent body scroll when drawer is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const closeMenu = () => {
    setIsOpen(false);
    setResourcesOpen(false);
  };

  return (
    <>
      {/* Dark overlay */}
      <div
        className={`nav-overlay ${isOpen ? 'open' : ''}`}
        onClick={closeMenu}
      />

      <nav className="navbar">
        <div className="nav-inner">
          <div className="nav-logo">
            <img src={logo} alt="Taleemul Quran Logo" />
          </div>

          {/* Desktop nav links */}
          <ul className="nav-links">
            <li><a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('home'); }}>Home</a></li>
            <li className="has-sub">
              <a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('courses'); }}>Our Courses</a>
              <ul className="submenu">
                <li><a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('noorani-qaida'); }}>Noorani Qaida</a></li>
                <li><a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('basic-quran-reading'); }}>Basic Quran Reading</a></li>
                <li><a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('quran-memorization'); }}>Quran Memorization</a></li>
                <li><a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('salah-kalmas-duas'); }}>Salah / Kalmas / Duas</a></li>
              </ul>
            </li>
            <li><a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('reviews'); }}>Reviews</a></li>
            <li><a href="#" className="link-ele" onClick={(e) => { e.preventDefault(); scrollTo('aboutus'); }}>About Us</a></li>
            <li><a href="#" className="link-ele nav-cta" onClick={(e) => { e.preventDefault(); scrollTo('contactus'); closeMenu(); }}>Contact Us</a></li>
          </ul>
          <div className='contactus-for-mobile'><a href="#" className="styles-c" onClick={(e) => { e.preventDefault(); scrollTo('contactus'); closeMenu(); }}><FaWhatsapp size={24} /></a></div>
          {/* Hamburger */}
          <button
            className="hamburger"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? '✕' : '☰'}
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      <ul className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        {/* Close button */}
        <li className="drawer-close">
          <button onClick={closeMenu} aria-label="Close menu">✕</button>
        </li>

        <li><a href="#" onClick={closeMenu}>Home</a></li>

        <li>
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); setResourcesOpen(!resourcesOpen); }}
          >
            Online Courses <span>{resourcesOpen ? '▴' : '▾'}</span>
          </a>
          <ul className={`mobile-submenu ${resourcesOpen ? 'open' : ''}`}>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollTo('noorani-qaida'); closeMenu(); }}>Noorani Qaida</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollTo('basic-quran-reading'); closeMenu(); }}>Basic Quran Reading</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollTo('quran-memorization'); closeMenu(); }}>Quran Memorization</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollTo('salah-kalmas-duas'); closeMenu(); }}>Salah / Kalmas / Duas</a></li>
          </ul>
        </li>

        <li><a href="#" onClick={(e) => { e.preventDefault(); scrollTo('aboutus'); closeMenu(); }}>About Us</a></li>
        <li><a href="#" onClick={(e) => { e.preventDefault(); scrollTo('contactus'); closeMenu(); }}>Contact Us</a></li>
      </ul>
    </>
  );
};

export default Menu;